import { IMessage } from '@eventr/common'
import {
    Gutters,
    Icon,
    Typography,
    VerticalExpander,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { Emoji } from 'emoji-picker-react'
import { FC, useState } from 'react'
import { ArrowFlip } from '../../../../assets/animated/arrowFlip'
import { getEmojiUnifiedFromRocketName } from '../../emoji/emojiFuncs'
import { rocketMembersOfChat } from '../chatProvider'
import { ActionSheetItem } from './actionSheetItem'

type TRocketReactionListProps = {
    message: IMessage
}

export const RocketReactionList: FC<TRocketReactionListProps> = ({
    message,
}) => {
    const [openState, setOpenState] = useState<boolean>(false)
    const reactions = message.reactions

    if (!reactions) {
        return null
    }

    return (
        <Box>
            <ActionSheetItem
                icon={<Icon name={'User'} />}
                label={
                    <Box
                        display={'grid'}
                        gridTemplateColumns={'1fr auto'}
                        width={'100%'}
                        padding={'0 16px 0 0'}
                    >
                        <Typography variant={'bodyRegular'}>
                            Reactions
                        </Typography>
                        <ArrowFlip open={!openState} />
                    </Box>
                }
                onClick={() => {
                    setOpenState(!openState)
                }}
            />
            <VerticalExpander open={openState}>
                <Gutters topPadding="8px">
                    <Box>
                        {Object.keys(reactions).map((reactionName) => {
                            if (!reactions[reactionName]) {
                                return null
                            }

                            return (
                                <Box
                                    key={reactionName}
                                    display={'grid'}
                                    gridTemplateColumns={'1fr auto'}
                                    gap={'4px'}
                                >
                                    <Box display={'grid'}>
                                        {reactions[reactionName].usernames.map(
                                            (username) => {
                                                const memberObj =
                                                    rocketMembersOfChat.value.find(
                                                        (memb) => {
                                                            return (
                                                                memb.username ===
                                                                username
                                                            )
                                                        }
                                                    )
                                                if (!memberObj) {
                                                    return null
                                                }
                                                return (
                                                    <Typography key={username}>
                                                        {memberObj.name}
                                                    </Typography>
                                                )
                                            }
                                        )}
                                    </Box>
                                    <Emoji
                                        unified={getEmojiUnifiedFromRocketName(
                                            reactionName
                                        )}
                                        size={16}
                                    />
                                </Box>
                            )
                        })}
                    </Box>
                </Gutters>
            </VerticalExpander>
        </Box>
    )
}
